module.exports = __webpack_public_path__ + "static/media/bancor.16b7966b.svg";